import React, {useState} from "react";
import ReCAPTCHA from "react-google-recaptcha";
import Config from "../config/config";
import Loader from "./loader";
import SubmitBoxMessage from "./SubmitBoxMessage";

const ApplyForJob = (props) => {
    const [selectedFile, setSelectedFile] = useState();
    const [isFilePicked, setIsFilePicked] = useState(false);
    const [isVerified, setIsVerified] = useState(false);
    const [loader, setLoader] = useState(false);

    const [captchaError, setCaptchaError] = useState('')
    const [firstErrors, setfirstErrors] = useState('');
    const [lastErrors, setlastErrors] = useState('');
    const [emailErrors, setEmailErrors] = useState('');
    const [mobileErrors, setMobileErrors] = useState('');
    const [uploadErrors, setUploadErrors] = useState('');
    const [isOpenMessageBox, setIsOpenMessageBox] = useState(false);
    const [values, setValues] = useState({
        firstName: '',
        lastName: '',
        email: '',
        mobile: '',
        linkedinUrl: '',
        websiteUrl: '',
        githubUrl: '',
    });
    const [message, setMessage] = useState({
        success: '',
        error: ''
    });

    const showMessage = () => {
        setIsOpenMessageBox(true)
    }
    const closeMessageBox = () => {
        setIsOpenMessageBox(false)
        setIsVerified(false);
        setSelectedFile('');
        setIsFilePicked(false)
        setMessage({
            success: ''
        });
        setMessage({
            error: ''
        });
    }

    function handleOnChange(value) {
        setIsVerified(true)
    }

    const handleFirstNameInputChange = (event) => {
        event.persist();
        setValues((values) => ({
            ...values,
            firstName: event.target.value,
        }));
    };
    const handleLastNameInputChange = (event) => {
        event.persist();
        setValues((values) => ({
            ...values,
            lastName: event.target.value,
        }));
    };

    const handleEmailInputChange = (event) => {
        event.persist();
        setValues((values) => ({
            ...values,
            email: event.target.value,
        }));
    };
    const handleMobileInputChange = (event) => {
        event.persist();
        setValues((values) => ({
            ...values,
            mobile: event.target.value,
        }));
    };
    const handleLinkedinInputChange = (event) => {
        event.persist();
        setValues((values) => ({
            ...values,
            linkedinUrl: event.target.value,
        }));
    };
    const handleWebsiteInputChange = (event) => {
        event.persist();
        setValues((values) => ({
            ...values,
            websiteUrl: event.target.value,
        }));
    };
    const handleGithubInputChange = (event) => {
        event.persist();
        setValues((values) => ({
            ...values,
            githubUrl: event.target.value,
        }));
    };

    const changeHandler = (event) => {

        var allowedFiles = [".pdf"];
        var fileUpload = document.getElementById("fileUpload");
        var lblError = document.getElementById("lblError");
        var regex = new RegExp("([a-zA-Z0-9\s_\\.\-:])+(" + allowedFiles.join('|') + ")$");
        if (!regex.test(fileUpload.value.toLowerCase())) {
            lblError.innerHTML = "Please upload files having extensions: <b>" + allowedFiles.join(', ') + "</b> only. ";
            event.target.files[0].value = '';
            return false;
        } else if (event.target.files[0].size > 2e6) {
            lblError.innerHTML = "Please upload a file smaller than 2 MB. ";
            event.target.files[0].value = '';
            return false;
        } else {
            event.persist();
            setSelectedFile(event.target.files[0]);
            setIsFilePicked(true);
        }
        lblError.innerHTML = "";
        return true;
    };


    const handleValidation = () => {
        let formIsValid = true;
        if (!isVerified) {
            formIsValid = false;
            setCaptchaError("Please fill re-captcha.");
        } else {
            setCaptchaError("")
        }
        if (values && !values.firstName) {
            formIsValid = false;
            setfirstErrors("Please enter your first name.");
        } else {
            setfirstErrors("")
        }
        if (values && !values.lastName) {
            formIsValid = false;
            setlastErrors("Please enter your last name.");
        } else {
            setlastErrors("")
        }
        if (!selectedFile) {
            formIsValid = false;
            setUploadErrors("Please upload resume/cv");
        } else {
            setUploadErrors("")
        }

        const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (values && values.email) {
            if (!regex.test(values.email)) {
                formIsValid = false;
                setEmailErrors("Please enter valid email.")
            } else {
                setEmailErrors("")
            }
        } else {
            setEmailErrors("Email field is required.")
        }

        if (values && values.mobile) {
            if (values.mobile && values.mobile.length !== 10) {
                formIsValid = false;
                setMobileErrors("Mobile number must have 10 digit.");
            } else {
                setMobileErrors("")
            }
        } else {
            setMobileErrors("Mobile field is required.")
        }

        return !captchaError && !firstErrors && !lastErrors && !emailErrors && !mobileErrors && !uploadErrors;
    }

    const handleSubmission = async (event) => {
        event.preventDefault();
        if (handleValidation()) {
            setLoader(true)
            const formData = new FormData();

            formData.append('file', selectedFile);
            formData.append('first_name', values.firstName)
            formData.append('last_name', values.lastName)
            formData.append('email', values.email)
            formData.append('phone', values.mobile)
            formData.append('linkedinUrl', values.linkedinUrl)
            formData.append('websiteUrl', values.websiteUrl)
            formData.append('githubUrl', values.githubUrl)
            formData.append('jobId', props.jobPostId)
            console.log(formData, "formData")
            fetch(
                `${Config.jobPostUrl}`,
                {
                    method: 'POST',
                    body: formData,
                }
            )
                .then((response) => response.json())
                .then((result) => {
                    setLoader(false)
                    setMessage({
                        success: result.message
                    });

                    console.log('Success:', result);

                    if (result.message) {
                        setValues({
                            firstName: '',
                            lastName: '',
                            email: '',
                            mobile: '',
                            linkedinUrl: '',
                            websiteUrl: '',
                            githubUrl: '',
                        });
                    }
                })
                .catch((error) => {
                    setMessage({
                        error: error
                    })
                    setLoader(false)
                    console.error('Error:', error);
                });
        }
    };
    console.log(message, 'success')


    return (
        <div className='container'>
            <div className="section-titl">
                <h5
                    style={{
                        fontSize: "18px",
                        fontWeight: "600",
                        color: " #1e3056",
                        padding: "30px 0 12px 0"
                    }}>Apply for this Job</h5>
            </div>
            <div className="job-info">
                <form style={{width: "100%"}}
                      className="form-group"
                      onSubmit={handleSubmission}
                >
                    <div className='row'>
                        <div className='col-lg-6 col-sm-6 col-xs-6 job-field-title'>
                            <label htmlFor="input-field" className="required-field">First Name</label>
                            <input
                                className="form-control"
                                type='text'
                                placeholder='First Name'
                                name='firstName'
                                value={values.firstName}
                                onChange={handleFirstNameInputChange}
                            />
                            {!!firstErrors && <span id='text-danger' style={{
                                color: "#D63301",
                            }}>{firstErrors}</span>}
                            <br/>
                        </div>
                        <div className='col-lg-6 col-sm-6 col-xs-6 job-field-title'>
                            <label htmlFor="input-field" className="required-field">Last Name</label>
                            <input
                                className="form-control"
                                type="text"
                                placeholder="Last Name"
                                name="lastName"
                                value={values.lastName}
                                onChange={handleLastNameInputChange}
                            />
                            {!!lastErrors && <span id='text-danger' style={{
                                color: "#D63301",
                            }}>{lastErrors}</span>}
                            <br/>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-lg-6 col-sm-6 col-xs-6 job-field-title'>
                            <label htmlFor="input-field" className="required-field">Email</label>
                            <input
                                className="form-control"
                                type="text"
                                placeholder="Email"
                                name="email"
                                value={values.email}
                                onChange={handleEmailInputChange}
                            />
                            {!!emailErrors && <span id='text-danger' style={{
                                color: "#D63301",
                            }}>{emailErrors}</span>}
                            <br/>
                        </div>
                        <div className='col-lg-6 col-sm-6 col-xs-6 job-field-title'>
                            <label htmlFor="input-field" className="required-field">Mobile number</label>
                            <input
                                className="form-control"
                                name="mobile"
                                type="number"
                                placeholder="Mobile Number"
                                value={values.mobile}
                                onChange={handleMobileInputChange}
                            />
                            {!!mobileErrors && <span id='text-danger' style={{
                                color: "#D63301",
                            }}>{mobileErrors}</span>}
                            <br/>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-lg-6 col-sm-6 col-xs-6 job-field-title'>
                            <label htmlFor="input-field" style={{fontSize: "18px"}}>Linkedin Url</label>
                            <input
                                className="form-control"
                                type='text'
                                placeholder='www.linkedin.com/us-en/'
                                name='linkedin'
                                value={values.linkedinUrl}
                                onChange={handleLinkedinInputChange}
                            />
                            <br/>
                        </div>
                        <div className='col-lg-6 col-sm-6 col-xs-6 job-field-title'>
                            <label htmlFor="input-field" style={{fontSize: "18px"}}>Website Url</label>
                            <input
                                className="form-control"
                                type='text'
                                placeholder='www.xyz.com'
                                name='website'
                                value={values.websiteUrl}
                                onChange={handleWebsiteInputChange}
                            />
                            <br/>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-lg-6 col-sm-6 col-xs-6 job-field-title'>
                            <label htmlFor="input-field" style={{fontSize: "18px"}}>Github Url</label>
                            <input
                                className="form-control"
                                type='text'
                                placeholder='www.github.com'
                                name='github'
                                value={values.githubUrl}
                                onChange={handleGithubInputChange}
                            />
                            <br/>
                        </div>
                        <div className='col-lg-6 col-sm-6 col-xs-6 job-field-title'>
                            <label htmlFor="input-field" className="required-field">Resume/CV</label>
                            <input
                                className="form-control"
                                id="fileUpload"
                                type="file"
                                name="file"
                                placeholder="File Name"
                                label="Resume/CV*"
                                onChange={changeHandler}
                            />
                            <span id="lblError" style={{color: "#D63301"}}></span>
                            {!isFilePicked && <span id='text-danger' style={{
                                color: "#D63301",
                            }}>{uploadErrors}</span>}
                        </div>
                    </div>

                    <ReCAPTCHA
                        sitekey="6LcKWIwfAAAAAKachCYyexLqdouLeYZHsqlCIm9J"
                        onChange={handleOnChange}
                    />
                    {!!captchaError && <span id='text-danger' style={{
                        color: "#D63301",
                    }}>{captchaError}</span>}
                    <br/>
                    <div>
                        <button type="submit" className="job-submit-btn" onClick={showMessage}>
                            Submit
                        </button>
                        {loader ? <Loader/> : ""}
                        {(isOpenMessageBox && (message.success || message.error)
                        ) && <SubmitBoxMessage
                            success={message.success}
                            handleClose={closeMessageBox}
                        />}
                    </div>
                </form>
            </div>
        </div>
    );
};

export default ApplyForJob;



// WEBPACK FOOTER //
// ./src/components/ApplyForJob.js